module.exports = __webpack_public_path__ + "static/media/pr11.bf6c562a.ogg";